import { RouteObject } from 'react-router';
import AuditLogs from './pages/AuditLogs/routes';
import UserManagement from './pages/UserManagement/routes';

export default [
  {
    path: '/admin',
    children: [...UserManagement, ...AuditLogs],
  },
] as RouteObject[];
